<script lang="ts" setup>
import { ButtonStyle } from '~/static/enums/components/button'
import AButton from '~/components/atoms/buttons/Button.vue'
import RModal from '~/components/organs/Modal.vue'

const openYMaps = () => {
  window.open('https://yandex.ru/profile/176658118910?intent=reviews', '_blank')
}

const refModal: Ref = ref(null)
const closeModal = () => {
  if (refModal.value !== null) {
    refModal.value.closeModal()
  }
}
const openModal = () => {
  if (refModal.value !== null) {
    refModal.value.openModal()
  }
}
defineExpose({
  closeModal,
  openModal,
})

</script>

<template>
  <RModal
    name-modal="SubscriptionByReview"
    ref="refModal"
  >
    <template #header>
      <h5
        class="modal-title fs-5"
        id="SubscriptionByReview"
      >
        Тариф «Старт» на 1 неделю бесплатно
      </h5>
    </template>
    <template #body>
      <ol>
        <li>Напишите, чем вам понравился Магви в отзывах на Яндекс Картах;</li>
        <li>
          Отправьте скриншот отзыва в «<a
            href="https://t.me/magvi_bot"
            target="_blank"
            class="text-dark"
          ><span class="hover text-decoration-underline">Поддержку</span></a>»;
        </li>
        <li>Проверим ваш отзыв в течение 5 рабочих дней и предоставим доступ к тарифу «Старт» 1 неделю.</li>
      </ol>
      Отзыв можно оставлять только один раз. Мы принимаем отзывы, оставленные лично вами.
    </template>
    <template #footer>
      <AButton
        :button-style="ButtonStyle.Primary"
        @click="openYMaps"
      >
        Оставить отзыв на Яндекс Картах
      </AButton>
    </template>
  </RModal>
</template>

<style lang="scss" scoped>
.body {
  width: 498px;
}
</style>
